export const pediatricsConst = {
  path: "/single-programs/pediatrics",
  title: "ФАКУЛЬТЕТ МЕДИЦИНЫ — ПЕДИАТРИЯ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> бакалавра
      </p>
      <p>
        <strong>Форма обучения:</strong> очная или дистанционная
      </p>
      <p>
        <strong>Форма связи:</strong> получить консультацию приемной комиссии
      </p>
      <h2>Педиатрия — искусство заботы о жизни с самого начала</h2>
      <p>
        <strong>Педиатрия</strong> — это больше, чем просто медицинская специальность. Это призвание помогать самым маленьким пациентам — от
        новорожденных до подростков. Программа готовит специалистов, способных выявлять, лечить и предотвращать детские заболевания,
        понимать особенности развития и обеспечивать комплексную поддержку детям и их семьям.
      </p>
      <p>
        Обучение направлено на формирование не только медицинских знаний, но и высокой эмпатии, внимательности и ответственности, которые
        необходимы при работе с детьми.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Анатомия и физиология детей</li>
        <li>Неонатология и уход за новорожденными</li>
        <li>Диагностика и лечение детских заболеваний</li>
        <li>Вакцинология и профилактика</li>
        <li>Генетические и наследственные патологии</li>
        <li>Психология и поведенческие расстройства</li>
        <li>Охрана материнства и детства</li>
        <li>Коммуникация с детьми и родителями</li>
        <li>Этические и правовые аспекты педиатрии</li>
      </ul>
      <p>
        Практическая подготовка проходит в детских клиниках, родильных домах, реабилитационных центрах и международных педиатрических
        учреждениях.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Врач-педиатр в государственной или частной клинике</li>
        <li>Неонатолог — специалист по уходу за новорожденными</li>
        <li>Консультант по детскому развитию и здоровью</li>
        <li>Медицинский эксперт в НКО или международных проектах</li>
        <li>Преподаватель детской медицины</li>
        <li>Специалист в области профилактики детских заболеваний</li>
      </ul>
      <h2>Востребованность и доход</h2>
      <p>Педиатры остаются одними из самых ценных специалистов в любой системе здравоохранения.</p>
      <p>
        <strong>Средний доход в Европе — от €55,000 до €95,000 в год,</strong> в зависимости от специализации и страны.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Международно признанный диплом</li>
        <li>Очная и дистанционная формы обучения</li>
        <li>Современная база и симуляционные технологии</li>
        <li>Стажировки в детских клиниках Европы</li>
        <li>Поддержка студентов на каждом этапе</li>
        <li>Обучение доступно на русском и английском языках</li>
      </ul>
      <h2>Учёба с заботой о будущем</h2>
      <p>
        Наши студенты обучаются у ведущих педиатров, проходят практику в лучших клиниках и участвуют в международных конференциях по
        детскому здоровью. Это обучение, которое помогает спасать жизни и формировать здоровое поколение.
      </p>
      <br />
      <p className="padding-left">
        «Педиатрия — это наука, основанная на любви и точности. Мы готовим тех, кому доверяют самое ценное — дети.»
      </p>
      <h2>Как поступить?</h2>
      <p>
        Заполните онлайн-заявку, прикрепите документы — и мы свяжемся с вами. Приёмная комиссия поможет сориентироваться и начать путь в
        педиатрию уже в этом году.
      </p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра
    Форма обучения: очная или дистанционная
    Форма связи: Получить консультацию приёмной комиссии

    Педиатрия — искусство заботы о жизни с самого начала
    Педиатрия — это больше, чем просто медицинская специальность. Это призвание помогать самым маленьким пациентам — от новорожденных до подростков. Программа готовит специалистов, способных выявлять, лечить и предотвращать детские заболевания, понимать особенности развития и обеспечивать комплексную поддержку детям и их семьям.
    Обучение направлено на формирование не только медицинских знаний, но и высокой эмпатии, внимательности и ответственности, которые необходимы при работе с детьми.

    Что вы будете изучать?
    • Анатомия и физиология детей
    • Неонатология и уход за новорожденными
    • Диагностика и лечение детских заболеваний
    • Вакцинология и профилактика
    • Генетические и наследственные патологии
    • Психология и поведенческие расстройства
    • Охрана материнства и детства
    • Коммуникация с детьми и родителями
    • Этические и правовые аспекты педиатрии
    Практическая подготовка проходит в детских клиниках, родильных домах, реабилитационных центрах и международных педиатрических учреждениях.

    Кем можно работать после окончания?
    • Врач-педиатр в государственной или частной клинике
    • Неонатолог — специалист по уходу за новорожденными
    • Консультант по детскому развитию и здоровью
    • Медицинский эксперт в НКО или международных проектах
    • Преподаватель детской медицины
    • Специалист в области профилактики детских заболеваний

    Востребованность и доход
    Педиатры остаются одними из самых ценных специалистов в любой системе здравоохранения.
    Средний доход в Европе — от €55,000 до €95,000 в год, в зависимости от специализации и страны.

    Почему выбирают нас?
    • Международно признанный диплом
    • Очная и дистанционная формы обучения
    • Современная база и симуляционные технологии
    • Стажировки в детских клиниках Европы
    • Поддержка студентов на каждом этапе
    • Обучение доступно на русском и английском языках

    Учёба с заботой о будущем
    Наши студенты обучаются у ведущих педиатров, проходят практику в лучших клиниках и участвуют в международных конференциях по детскому здоровью. Это обучение, которое помогает спасать жизни и формировать здоровое поколение.
    «Педиатрия — это наука, основанная на любви и точности. Мы готовим тех, кому доверяют самое ценное — дети.»

    Как поступить?
    Заполните онлайн-заявку, прикрепите документы — и мы свяжемся с вами. Приёмная комиссия поможет сориентироваться и начать путь в педиатрию уже в этом году.

  `,
};
